import React, { FC } from 'react';
import AntCheckbox, { CheckboxProps as AntCheckboxProps } from 'antd/lib/checkbox';
import './Checkbox.scss';
import { twMerge } from '@shared/utils/twMerge';

type Colors =
  | 'vividTangelo'
  | 'vermilion'
  | 'dodgerBlue'
  | 'minionYellow'
  | 'munsellPurple'
  | 'limeGreen';

type CheckboxProps = AntCheckboxProps & {
  className?: string;
  dark?: boolean;
  children?: React.ReactNode;
  color?: Colors;
};

export const Checkbox: FC<CheckboxProps> = ({
  className,
  dark,
  color = 'dodgerBlue',
  ...props
}) => {
  return (
    <AntCheckbox
      className={twMerge('D7-Checkbox', color, dark && 'dark', className)}
      {...props}
    />
  );
};
